import {Log, LogTag} from "../Log";
import * as websocket from 'websocket';
import {IPlayerService} from "../../interfaces/IPlayerService";
import {PlayerPwaService} from "./player.pwa.service";
import {debounce, Subject, switchMap, throttle, throttleTime} from "rxjs";
import {debounceTime, delay} from "rxjs/operators";
import {ILogInfo} from "../../interfaces/ILogInfo";

export class ServerSocket {
  private playerService: IPlayerService;
  private client;
  private lastStudioCommand;
  private msg: any = {};
  private $send = new Subject();
  private receiveMsg = false;
  private noReplayCount = 0;


  constructor(playerService: IPlayerService) {
    const logInfo = Log.getLogInfo("ServerSocket", "constructor", []);
    this.playerService = playerService;

    this.$send.pipe(
      debounceTime(2000)
    ).subscribe( r => {
      if (this.client != null) {
        try {
          const text = JSON.stringify(this.msg);
          this.client.send(text);
          Log.d(logInfo, LogTag.WEBSOCKET, 'send: ' + text);
        } catch (e) {
        }
      }
    })


    setInterval(()=> {
      if (this.client!=null) {
        const msg = {
          command: "player_ping",
          businessId: this.playerService.businessId,
          stationId: (<PlayerPwaService>this.playerService).stationId
        }
        if (this.client!=null) {
          try {
            this.noReplayCount++;
            if (this.noReplayCount<3) {
              this.client.send(JSON.stringify(msg));
            } else {
              this.client.close();
              this.clean();
            }
          } catch (e) {
          }
        }
      }
    }, 5000);
  }

  create(fnConnect: Function, fnData: Function, fnClose: Function) {
    const logInfo = Log.getLogInfo("ServerSocket", "create", []);
    try {
      const url = 'wss://'+this.playerService.businessDomain+'/Web/playerWebSocket.ashx';
      this.client = new websocket.w3cwebsocket(url);
    } catch (e) {
      Log.w(logInfo, LogTag.WEBSOCKET, 'websocket Exception!');
      fnClose();
      return;
    }

    this.client.onopen = () => {
      Log.d(logInfo, LogTag.WEBSOCKET, 'Connected');
      if (this.client.readyState === this.client.OPEN) {
        this.lastStudioCommand = new Date().getTime();
        this.receiveMsg = true;
        const init = {
          command: "init",
          businessId: this.playerService.businessId,
          stationId: (<PlayerPwaService>this.playerService).stationId,
          stationToken: (<PlayerPwaService>this.playerService).stationToken
        }
        this.client.send(JSON.stringify(init));

        this.msg = {
          command: "status",
          businessId: this.playerService.businessId,
          stationId: (<PlayerPwaService>this.playerService).stationId,
        }
        fnConnect();
      }
    };

    this.client.onerror = (err) => {
      Log.w(logInfo, LogTag.WEBSOCKET, 'Connection Error: ' + err);
      this.clean();
    };

    this.client.onclose = (a) => {
      Log.w(logInfo, LogTag.WEBSOCKET, 'echo-protocol Client Closed');
      this.clean();
      fnClose();
    };

    this.client.onmessage = (e) => {
      if (typeof e.data === 'string') {
        //Log.d(this, LogTag.WEBSOCKET, e.data);

        this.lastStudioCommand = new Date().getTime();
        if (this.receiveMsg==false) {
          this.receiveMsg = true;
          Log.d(logInfo, LogTag.WEBSOCKET, "start sending status");
          this.$send.next("send");
        }
        const data = JSON.parse(e.data);
        if (data.command=="player_pong") {
          this.noReplayCount = 0;
        }
        fnData(data);
      } else {
        // TEST ONLY ???
        if (this.playerService.businessId==315462) {
          const blob = <Blob>e.data;
          var url = URL.createObjectURL(blob);
          const audio = new Audio();
          audio.src = url;
          audio.play();
        }
      }
    };
  }

  sendStatus(key: string, value: any) {
    const now = new Date().getTime();
    if (now - this.lastStudioCommand > 20000) {
      this.receiveMsg = false;
    }
    if (this.msg[key] == null || this.msg[key] != value) {
      this.msg[key] = value;
      if (this.receiveMsg) {
        this.$send.next("send");
      }
    }
  }

  sendPttInfo() {
    const pttInfo = JSON.parse(localStorage['ptt']);
    const msg = {
      command: "ptt",
      businessId: this.playerService.businessId,
      stationId: (<PlayerPwaService>this.playerService).stationId,
      info: pttInfo
    }
    this.client.send(JSON.stringify(msg));
  }

  clean() {
    this.client = null;
    this.msg = {};
  }
}
